import type { Config } from 'next-i18n-router/dist/types'

import { DEFAULT_LOCALE, JAPAN_LOCALE } from '~/core/constants/env'

export const LOCALE_COOKIE = 'NEXT_LOCALE'

const i18nConfig: Config = {
  locales: [DEFAULT_LOCALE, JAPAN_LOCALE],
  defaultLocale: DEFAULT_LOCALE,
  prefixDefault: false,
  localeCookie: LOCALE_COOKIE,
  serverSetCookie: 'always',

  basePath: undefined,
  localeDetector: false // We handle detection manually in middleware
}

export default i18nConfig
